import { defineMessages } from 'react-intl'

export const messages = defineMessages({
  towingReasonHeader: { id: 'towingCommon.jobDetails.towingReasonHeader', defaultMessage: 'Vika' },
  causeAndDeliverableHeader: {
    id: 'towingCommon.jobDetails.causeAndDeliverableHeader',
    defaultMessage: 'Vika ja toimenpide',
  },
  referenceHeader: { id: 'towingCommon.jobDetails.referenceHeader', defaultMessage: 'Viite' },
  sosReferenceHeader: { id: 'towingCommon.jobDetails.sosReferenceHeader', defaultMessage: 'SOS Viite' },
  situationEstimateHeader: {
    id: 'towingCommon.jobDetails.situationEstimateHeader',
    defaultMessage: 'Tilannearvio',
  },
  autoliittoSituationEstimateHeader: {
    id: 'towingCommon.jobDetails.autoliittoSituationEstimateHeader',
    defaultMessage: 'Autoliiton tilannearvio',
  },
  billingHeader: { id: 'towingCommon.jobDetails.billingHeader', defaultMessage: 'Laskutus' },
  arcFaultCodeHeader: { id: 'towingCommon.jobDetails.arcFaultCodeHeader', defaultMessage: 'ARC-vikakoodi' },
  serviceChannelAndBillingHeader: {
    id: 'towingCommon.jobDetails.serviceChannelAndBillingHeader',
    defaultMessage: 'Palvelukanava ja laskutus',
  },
  momentSituationEstimateHeader: {
    id: 'towingCommon.jobDetails.momentSituationEstimateHeader',
    defaultMessage: 'MOMENT Tilannearvio',
  },
  sosNotesHeader: { id: 'towingCommon.jobDetails.sosNotesHeader', defaultMessage: 'SOS Merkinnät' },
  conceptHeader: { id: 'towingCommon.jobDetails.conceptHeader', defaultMessage: 'Konsepti' },
  jobInfoHeader: { id: 'towingCommon.jobDetails.jobInfoHeader', defaultMessage: 'Työn tiedot' },
  serviceCenterHeader: { id: 'towingCommon.jobDetails.serviceCenterHeader', defaultMessage: 'Palvelukeskus' },
  serviceCenterMoment: { id: 'towingCommon.jobDetails.serviceCenterMoment', defaultMessage: 'Moment' },
  serviceCenterSos: { id: 'towingCommon.jobDetails.serviceCenterSos', defaultMessage: 'SOS' },
  towingDateLabel: { id: 'towingCommon.jobDetails.towingDateLabel', defaultMessage: 'Päivämäärä' },
  towingTimeLabel: { id: 'towingCommon.jobDetails.towingTimeLabel', defaultMessage: 'Aika' },
  orderReferenceLabel: { id: 'towingCommon.jobDetails.orderReferenceLabel', defaultMessage: 'Tilauksen viite' },
  incidentCaseNoLabel: { id: 'towingCommon.jobDetails.incidentCaseNoLabel', defaultMessage: 'Vahinkotunnus' },
  towingReasonLabel: { id: 'towingCommon.jobDetails.towingReasonLabel', defaultMessage: 'Hinauksen syy' },
  serviceTypeLabel: { id: 'towingCommon.jobDetails.serviceTypeLabel', defaultMessage: 'Toimenpide' },
  additionalInfoLabel: { id: 'towingCommon.jobDetails.additionalInfoLabel', defaultMessage: 'Lisäselvitykset' },
  notesLabel: { id: 'towingCommon.jobDetails.notesLabel', defaultMessage: 'Muistiinpanot' },
})
